// import api from "./axiosInstance";

// export const getPublicClasses = (filters = {}) => {
//   const params = new URLSearchParams();
//   Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
//   return api.get(`/public/classes?${params.toString()}`);
// };

import api from "./axiosInstance";

/* ── List activities with optional filters ── */
export const getPublicActivities = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
  return api.get(`/public/activities?${params.toString()}`);
};

/* ── Single activity by ID ── */
export const getPublicActivityById = (id) => api.get(`/public/activities/${id}`);

/* ── ⭐ Toggle Save / Unsave Activity ── */
export const toggleSavedActivity = (data) => api.post("/activities/bookmark-activity", data);

export const getSavedActivities = (parentId) =>
  api.get(`/activities/saved-activities/${parentId}`);

/* ── List events with optional filters ── */
export const getPublicEvents = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
  return api.get(`/public/events?${params.toString()}`);
};

/* ── Single event by ID ── */
export const getPublicEventById = (id) => api.get(`/public/events/${id}`);

/* ── ⭐ Toggle Save / Unsave Event ── */
export const toggleSavedEvent = (data) => api.post("/events/bookmark-event", data);

export const getSavedEvents = (parentId) => api.get(`/events/saved-events/${parentId}`);

/* ── List childcare facilities (public) ── */
export const getPublicChildcareFacilities = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
  return api.get(`/childcare/facilities?${params.toString()}`);
};

/* ── List schools with optional filters ── */
export const getPublicSchools = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
  return api.get(`/public/schools?${params.toString()}`);
};

/* ── School reviews from class_reviews.school_id ── */
export const getSchoolClassReviews = (registrationId) =>
  api.get(`/public/schools/${registrationId}/class-reviews`);

/* ── List with optional filters ── */
export const getPublicClasses = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
  return api.get(`/public/classes?${params.toString()}`);
};

/* ── Single class by ID (gallery + reviews included) ── */
export const getPublicClassById = (id) => {
  return api.get(`/public/classes/${id}`);
};

/* ── Submit a review ── */
export const submitClassReview = (classId, payload) => {
  return api.post(`/public/classes/${classId}/reviews`, payload);
};

/* ── Contact form submission ── */
export const submitContactForm = (data) => api.post("/public/contact", data);
/* ─────────────────────────────────────────────────────────────
   ADD / REPLACE this in your publicService.js
   (wherever getPublicClasses, getPublicClassById live)

   The key fix: the review body now sends parent_account_id
   (not parent_id), and the endpoint is /public/classes/:id/reviews
───────────────────────────────────────────────────────────── */

// Assuming your publicService.js uses an axios instance like:
// import api from "./axiosInstance";
// or:
// import axios from "axios";
// const api = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL });

// export const getPublicClasses = (filters = {}) =>
//   api.get("/public/classes", { params: filters });

// export const getPublicClassById = (id) =>
//   api.get(`/public/classes/${id}`);

/**
 * Submit a class review.
 *
 * @param {number|string} classId
 * @param {object} data
 *   - parent_account_id  (required)  ← use parentData?.parentAccount?.id
 *   - child_id           (optional)
 *   - rating             (required, 1–5)
 *   - review_text        (optional)  ← the main review of the class
 *   - review_school      (optional)
 *   - review_instructor  (optional)
 *   - school_rating      (optional, 1–5)
 *   - instructor_rating  (optional, 1–5)
 *   - class_rating       (optional, 1–5)
 */
// export const submitClassReview = (classId, data) =>
//   api.post(`/public/classes/${classId}/reviews`, data);